import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import s from "./styles.module.css";
import useAuth from "../../../../hooks/useAuth";
import { addAgent } from "../../model/agents";
import { addAgentFields } from "../../../../data/Fields";
import CustomInput from "../../../../shared/components/CustomInput";
import { useNavigate } from "react-router-dom";

const AddAgent = () => {
  const dispatch = useDispatch();
  const { status } = useSelector((state) => state.agents);
  const [selectedImages, setSelectedImages] = useState([]);
  const { auth } = useAuth();
  const token = auth?.access_token;
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setValue("photo", file);
      setSelectedImages([URL.createObjectURL(file)]);
    } else {
      console.log("Файл не выбран");
    }
  };

  const onSubmit = (data) => {
    const formData = new FormData();

    formData.append("name", data?.name);
    formData.append("email", data?.email);
    formData.append("whats_app", data?.whats_app);
    formData.append("surname", data?.surname);
    formData.append("phone_number", data?.phone_number);
    formData.append("group", data?.group);
    formData.append("password", data?.password);

    if (data?.photo) {
      formData.append("photo", data?.photo);
    } else {
      return;
    }

    dispatch(addAgent({ formData, token })).then((action) => {
      if (action.type.endsWith("fulfilled")) {
        reset();
        setSelectedImages([]);
        navigate("/agentsList");
      }
    });
  };

  return (
    <div className="container">
      <h1 className="title">Добавление нового агента</h1>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={s.form}>
          <div className={s.column}>
            {addAgentFields &&
              addAgentFields.map((field) => (
                <div key={field.name} className={s.inputBox}>
                  <CustomInput
                    name={field.name}
                    label={field.label}
                    placeholder={field.placeholder}
                    type={field.type || "text"}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message || ""}
                    inputRef={register(field.name, field.validation || {}).ref}
                    {...register(field.name, field.validation || {})}
                  />
                </div>
              ))}
          </div>

          {/* Блок добавления изображений */}
          <div className={s.imageUploadContainer}>
            <label htmlFor="photos"></label>
            <input
              name="photo"
              type="file"
              onChange={handleImageChange}
              required
            />

            <div className={s.imagePreview}>
              {selectedImages.length > 0 ? (
                selectedImages.map((src, index) => (
                  <img
                    key={index}
                    src={src}
                    alt={`Выбранное изображение ${index + 1}`}
                    className={s.thumbnail}
                  />
                ))
              ) : (
                <p>Выберите фото</p>
              )}
            </div>
            {errors.photo && <span>Фото обязательно для загрузки</span>}
          </div>
        </div>
        <div className="centerLoading">
          {status === "loading" ? (
            <div className="loader"></div>
          ) : (
            <button type="submit" className="saveButton">
              Добавить агента
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AddAgent;
